var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiMoonrise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,14.86c0-0.98,0.19-1.92,0.58-2.82c0.38-0.9,0.9-1.67,1.55-2.32c0.65-0.65,1.43-1.17,2.32-1.56s1.84-0.58,2.83-0.58 h1.17c0.16,0.04,0.24,0.14,0.24,0.28l0.04,0.9c0.04,1.3,0.51,2.41,1.41,3.33s2,1.41,3.28,1.46l0.85,0.07c0.16,0,0.23,0.08,0.23,0.23 v1.01c0.01,1.03-0.19,2-0.58,2.92h-2.05c0.51-0.74,0.83-1.59,0.97-2.53c-1.67-0.35-3.02-1.07-4.03-2.16s-1.59-2.37-1.75-3.83 c-0.97,0.05-1.85,0.35-2.66,0.9c-0.8,0.55-1.43,1.24-1.87,2.08c-0.44,0.84-0.66,1.72-0.66,2.63c0,1.07,0.28,2.04,0.83,2.92H8.4 C8,16.85,7.8,15.88,7.8,14.86z M8.09,20.87c0-0.29,0.09-0.52,0.28-0.68c0.18-0.18,0.41-0.26,0.69-0.26h2.63L14.8,17 c0.1-0.08,0.22-0.08,0.35,0l3.16,2.92h2.77c0.27,0,0.5,0.09,0.69,0.28c0.19,0.18,0.29,0.41,0.29,0.67c0,0.27-0.1,0.5-0.29,0.69 c-0.19,0.19-0.42,0.29-0.69,0.29h-3.38c-0.1,0-0.2-0.02-0.29-0.07l-2.41-2.27l-2.39,2.27c-0.08,0.05-0.17,0.07-0.28,0.07H9.06 c-0.27,0-0.5-0.1-0.69-0.29S8.09,21.14,8.09,20.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiMoonrise);
export default __webpack_public_path__ + "static/media/wi-moonrise.58ac37eb82494c18537be8fa40d15408.svg";
export { ForwardRef as ReactComponent };